import React from 'react'

import dashboardActiveIcon from '../../assets/HRAsserts/HeaderIcons/dashboardActive.svg';
import dashboardIcon from '../../assets/HRAsserts/HeaderIcons/dashboardInactive.svg';
import analyticsActiveIcon from '../../assets/HRAsserts/HeaderIcons/analyticsActive.svg';
import analyticsIcon from '../../assets/HRAsserts/HeaderIcons/analyticsInactive.svg';
import allowanceActiveIcon from '../../assets/HRAsserts/HeaderIcons/allowanceActiveIcon.svg';
import allowanceIcon from '../../assets/HRAsserts/HeaderIcons/allowanceIcon.svg';
import reportAtiveIcon from '../../assets/HRAsserts/HeaderIcons/reportActive.svg';
import reportIcon from '../../assets/HRAsserts/HeaderIcons/reportInactive.svg';
import setupActiveIcon from '../../assets/HRAsserts/HeaderIcons/setupActive.svg';
import setupIcon from '../../assets/HRAsserts/HeaderIcons/setupInactive.svg';
import geoLocationActiveIcon from '../../assets/HRAsserts/HeaderIcons/locationActive.svg';
import geoLocationIcon from '../../assets/HRAsserts/HeaderIcons/locationInactive.svg';
import timeLineEmptyIcon from '../../assets/HRAsserts/Icons/timelineEmpty.png';

import shiftIcon from '../../assets/HRAsserts/Icons/SetUpIcons/shiftsIcon.svg';

import reportBanner from '../../assets/HRAsserts/Icons/reportBanner.svg';


import absenceIcon from '../../assets/HRAsserts/UserInfoIcon/absenceIcon.svg';
import presentIcon from '../../assets/HRAsserts/UserInfoIcon/presentIcon.svg';
import fineIcon from '../../assets/HRAsserts/UserInfoIcon/fineIcon.svg';
import halfHourIcon from '../../assets/HRAsserts/UserInfoIcon/halfHourIcon.svg';
import leaveIcon from '../../assets/HRAsserts/UserInfoIcon/leaveIcon.svg';
import lateIcon from '../../assets/HRAsserts/UserInfoIcon/lateLoginIcon.svg';
import overtimeIcon from '../../assets/HRAsserts/UserInfoIcon/overtimeIcon.svg';
import permissionIcon from '../../assets/HRAsserts/UserInfoIcon/permissionIcon.svg';


import leaveFormHeader from '../../assets/ClientAsserts/LeaveTeamplateImages/header.svg';
import leaveFormFooter from '../../assets/ClientAsserts/LeaveTeamplateImages/footer.svg';




const HRImages = {
  dashboardActiveIcon,
  dashboardIcon,
  allowanceActiveIcon,
  allowanceIcon,
  analyticsActiveIcon,
  analyticsIcon,
  reportAtiveIcon,
  reportIcon,
  setupActiveIcon,
  setupIcon,
  geoLocationActiveIcon,
  geoLocationIcon,
  timeLineEmptyIcon,
  reportBanner,


  shiftIcon,

  absenceIcon,
    presentIcon,
    fineIcon,
    halfHourIcon,
    leaveIcon,
    lateIcon,
    overtimeIcon,
    permissionIcon,

    leaveFormHeader,
    leaveFormFooter,
  
};

export default HRImages